import { RootState } from "@/app/stores";
import {
    enableWhitelist,
    disableWhitelist,
    listWhitelistedPhones,
    createWhitelistEntry,
    deleteWhitelistEntry,
    bulkCreateWhitelistEntries,
    bulkCreateWhitelistEntriesFromCSV,
    CreatePhoneWhitelistRequest,
    BulkCreatePhoneWhitelistRequest,
    CommunityAdminDTO
} from "@/shared/api/phone-whitelist";
import { ErrorType } from "@/shared/types";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { updateWhitelistStatus } from "@/entities/community";

export const fetchEnableWhitelist = createAsyncThunk<
    CommunityAdminDTO,
    null,
    { state: RootState }
>('phoneWhitelist/enableWhitelist', async (_, thunkAPI) => {
    try {
        const data = await enableWhitelist();
        thunkAPI.dispatch(updateWhitelistStatus(data.data.is_whitelist_enabled));
        return data.data;
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>;
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        });
    }
});

export const fetchDisableWhitelist = createAsyncThunk<
    CommunityAdminDTO,
    null,
    { state: RootState }
>('phoneWhitelist/disableWhitelist', async (_, thunkAPI) => {
    try {
        const data = await disableWhitelist();
        thunkAPI.dispatch(updateWhitelistStatus(data.data.is_whitelist_enabled));
        return data.data;
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>;
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        });
    }
});

export const fetchWhitelistedPhones = createAsyncThunk<
    any[],
    null,
    { state: RootState }
>('phoneWhitelist/fetchWhitelistedPhones', async (_, thunkAPI) => {
    try {
        const data = await listWhitelistedPhones();
        return data.data;
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>;
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        });
    }
});

export const fetchCreateWhitelistEntry = createAsyncThunk<
    any,
    CreatePhoneWhitelistRequest,
    { state: RootState }
>('phoneWhitelist/createWhitelistEntry', async (payload, thunkAPI) => {
    try {
        const data = await createWhitelistEntry(payload);
        return data.data;
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>;
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        });
    }
});

export const fetchDeleteWhitelistEntry = createAsyncThunk<
    string,
    string,
    { state: RootState }
>('phoneWhitelist/deleteWhitelistEntry', async (id, thunkAPI) => {
    try {
        await deleteWhitelistEntry(id);
        return id;
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>;
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        });
    }
});

export const fetchBulkCreateWhitelistEntries = createAsyncThunk<
    any,
    BulkCreatePhoneWhitelistRequest,
    { state: RootState }
>('phoneWhitelist/bulkCreateWhitelistEntries', async (payload, thunkAPI) => {
    try {
        const data = await bulkCreateWhitelistEntries(payload);
        return data.data;
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>;
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        });
    }
});

export const fetchBulkCreateWhitelistEntriesFromCSV = createAsyncThunk<
    any,
    File,
    { state: RootState }
>('phoneWhitelist/bulkCreateWhitelistEntriesFromCSV', async (file, thunkAPI) => {
    try {
        const data = await bulkCreateWhitelistEntriesFromCSV(file);
        return data.data;
    } catch (err: unknown) {
        const knownError = err as AxiosError<ErrorType>;
        return thunkAPI.rejectWithValue({
            message: knownError.response?.data?.message,
            error_id: knownError.response?.data?.error_id
        });
    }
});

